import { useState, useEffect, useRef } from 'react';
import { Button } from 'primereact/button';
import { useAuth } from '../providers/auth';
import api from "../services/api";
import { useToast } from '../context/ToastContext';
import { Divider } from 'primereact/divider';
import { useForm } from 'react-hook-form';
import { SCButton, SCCheckbox, SCDropdown, SCInputText } from '../components';
import { SlideMenu } from 'primereact/slidemenu';
import AjudaFormTela from './AjudaFormTela';
import { ALERTAS, APROVA_BASE, COMBO_ANO, LISTA_SEQUENCIAL } from '../utilities/constantes';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import IDisciplinaAprovaBaseMedia from '../interfaces/IDisciplinaAprovaBaseMedia';
import Loading from '../components/Loading';
import IPlanoPagamentoTurma from '../interfaces/IPlanoPagamentoTurma';
import ITurmas from '../interfaces/ITurmas';
import { CheckboxChangeParams } from 'primereact/checkbox';
import ITurmaAuxiliar from '../interfaces/ITurmaAuxiliar';
import { format, getYear, parseISO, setYear } from 'date-fns';

interface ITurma {
  TurmaId: number;
  TurmaCodigo: string;
  TurmaDescricao: string;

}

const IniciaPeriodoTurma = () => {
  const toast = useToast();
  const { periodoSelecionado } = useAuth();
  const tarefa = 'DisciplinaAprovaBaseMedia';

  const [todosSelecionados, setTodosSelecionados] = useState(false);
  const [inverterSelecao, setInverterSelecao] = useState(false);
  const [selectedTurma, setSelectedTurma] = useState<any>(null);
  const [onlySelected, setOnlySelected] = useState(false);
  const [turmas, setTurmas] = useState<any[]>([]);

  const [desativarComboTurma, setDesativarComboTurma] = useState<boolean>(false);
  const [desativarComboTurmaAux, setDesativarComboTurmaAux] = useState<boolean>(false);

  const [globalFilter, setGlobalFilter] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [copia, setCopia] = useState<any>(null);

  const dt = useRef<any>(null);
  const menu = useRef<any>(null);

  const methods = useForm();
  const { handleSubmit, control, formState: { errors }, watch, setValue, getValues, reset } = methods;

  const watchAno = watch('Ano')
  const watchSequencial = watch('Sequencial')
  const watchDescricao = watch('Descricao')

  const load = async () => {
    setLoading(true);

    try {

      let consultaTurmas = await api.get('/turma/todasTurmas', {
        params: {
          EmpresaId: periodoSelecionado?.EmpresaId,
          Ano: periodoSelecionado?.Ano,
          Sequencial: periodoSelecionado?.Sequencial
        }
      })

      if (consultaTurmas.data) {
        // console.log(consultaTurmas.data)
        setTurmas(consultaTurmas.data || [])
      }


    } catch (e: any) {
      console.error(e.response?.data);
      toast.showToast({ severity: 'error', summary: 'Erro', detail: e?.response?.data?.error });
    } finally {
      setLoading(false);
    }
  };

  const handleCheckboxChange = (rowData: any, checked: boolean) => {
    const updatedPlanoPagamentoTurma = turmas.map((item: any) => {
      if (item.TurmaId === rowData.TurmaId) {
        return { ...item, Selecionado: checked ? 1 : 0 };
      }
      return item;
    });

    console.log(updatedPlanoPagamentoTurma)

    setTurmas(updatedPlanoPagamentoTurma);
  };

  const funcaoGravaPeriodo = async () => {

    let dadosPeriodo = {
      EmpresaId: periodoSelecionado?.EmpresaId,
      Ano: watchAno,
      Sequencial: watchSequencial,
      Descricao: watchDescricao
    }

    try {
      let gravaPeriodo = await api.post('periodos/create', dadosPeriodo)

      if (gravaPeriodo) {
        toast.showToast({ severity: 'success', summary: 'Atenção', detail: 'Registro salvo com sucesso!' });
      }

    } catch (e: any) {
      console.log('Erro ao gravar período!')
      toast.showToast({ severity: 'error', summary: 'Erro', detail: e?.response?.data?.error });
    }
  }

  const funcaoSalvaParametro = async () => {
    const consulta = await api.get('/parametros/listaParametrosAnoPeriodo', {
      params: {
        EmpresaId: periodoSelecionado?.EmpresaId,
        Ano: periodoSelecionado?.Ano,
        Sequencial: periodoSelecionado?.Sequencial
      }
    });

    if (consulta.data.length > 0) {
      const resultado = consulta.data;

      const mapeandoResultado = resultado.map(({ Id, ...parametro }: any) => {
        return {
          ...parametro,
          EmpresaId: periodoSelecionado?.EmpresaId,
          Ano: watchAno,
          Sequencial: watchSequencial
        };
      });

      try {

        await api.post('/parametros/gravaNovoPeriodo', {
          parametros: mapeandoResultado
        });

      } catch (error) {
        console.error('Erro ao salvar parâmetros:', error);
      }
    }
  };

  const funcaoGravaTurmas = async () => {
    let turmasSelecionadas = turmas.filter((t: any) => t.Selecionado === 1)

    try {
      if (turmasSelecionadas.length > 0) {
        turmasSelecionadas = turmasSelecionadas.map(({ TurmaId, Selecionado, TurmaDescricao, ...resto }) => {
          return {
            ...resto,
            EmpresaId: periodoSelecionado?.EmpresaId,
            Ano: watchAno,
            Sequencial: watchSequencial,
            VagasOcupadas: 0,
            VagasRegistradas: 0
          }
        })

        await api.post('/turma/gravaTurmasAnoPeriodo', { turmas: turmasSelecionadas })
      }
    } catch (error: any) {
      console.log('Atenção:', error?.message)
    }
  }

  const funcaoGravaOfertaTurma = async () => {
    let turmasSelecionadas = turmas.filter((t: any) => t.Selecionado === 1)

    try {
      const lendoTurmasSelecionadas = await Promise.all(
        turmasSelecionadas.map(async (turma: any) => {
          const consultaTurmasAnoPeriodo = await api.get('/ofertaDisciplina/listaOferta', {
            params: {
              EmpresaId: periodoSelecionado?.EmpresaId,
              Ano: periodoSelecionado?.Ano,
              Sequencial: periodoSelecionado?.Sequencial,
              TurmaCodigo: turma.Codigo
            }
          })

          return consultaTurmasAnoPeriodo.data
        })
      )

      console.log('Resultados:', lendoTurmasSelecionadas)

      const dadosOfertaAnoPeriodo = lendoTurmasSelecionadas
        .flat()
        .map(({ OfertaDisciplinaId, ...resto }) => ({
          ...resto,
          EmpresaId: periodoSelecionado?.EmpresaId,
          Ano: watchAno,
          Sequencial: watchSequencial
        }))


      let gravando = await api.post('/ofertaDisciplina/gravaOfertaAnoPeriodo', { ofertas: dadosOfertaAnoPeriodo })

      if (gravando) {
        console.log('Ofertas salvas com sucesso!')
      }

    } catch (error: any) {
      console.error('Erro ao consultar turmas:', error?.message)
    }
  }

  const funcaoGravaNivelSequencia = async () => {

    try {
      const consultaNivelSequencia = await api.get('/nivelSequencia/lendoNivelSequencia', {
        params: {
          EmpresaId: periodoSelecionado?.EmpresaId,
          Ano: periodoSelecionado?.Ano,
          Sequencial: periodoSelecionado?.Sequencial
        }
      })

      if (consultaNivelSequencia.data.length > 0) {
        console.log(consultaNivelSequencia.data)

        let dadosSalvar = consultaNivelSequencia.data.map((item: any) => {
          const { NivelSequenciaId, ...resto } = item;
          return {
            ...resto,
            EmpresaId: periodoSelecionado?.EmpresaId,
            Ano: watchAno,
            Sequencial: watchSequencial
          };
        });

        let gravando = await api.post('/nivelSequencia/gravaNivelSequencia', { nivel: dadosSalvar })

        if (gravando) {
          console.log('Nivel Sequencia salvo com sucesso')
        }
      }

    } catch (error) {
      console.log(error)
    }
  }

  const funcaoGravaPlanoPagamento = async () => {
    try {

      const consultaPlanos = await api.get('/planosPagamento/consultaPlanosPagamento', {
        params: {
          Ano: periodoSelecionado?.Ano,
        }
      })

      if (consultaPlanos.data.length > 0) {

        let dadosRetornados = consultaPlanos.data;
        await Promise.all(
          dadosRetornados.map(async (planoPagamento: any) => {
            let { PlanosPagamentoId, ...resto } = planoPagamento
            const arrayGravacao = {
              ...resto,
              Ano: watchAno
            }

            let gravando = await api.post('/planosPagamento/gravaPlanoPagamento', {
              planos: arrayGravacao,
              idAntigo: PlanosPagamentoId,
              anoSelecionado: watchAno,
              sequencialSelecionado: watchSequencial,
            })
          })
        )
      }

    } catch (error) {
      console.log('Erro em consultar os Planos de Pagamento')
    }
  }

  const funcaoGravaBoletimColunas = async () => {
    try {

      const consultaBoletimColunas = await api.get('/boletimColunas', {
        params: {
          EmpresaId: periodoSelecionado?.EmpresaId,
          Ano: periodoSelecionado?.Ano,
          Sequencial: periodoSelecionado?.Sequencial,
        }
      })

      if (consultaBoletimColunas.data.length > 0) {

        let dadosRetornados = consultaBoletimColunas.data;
        await Promise.all(
          dadosRetornados.map(async (boletimColuna: any) => {
            let { BoletimColunasId, ...resto } = boletimColuna
            const arrayGravacao = {
              ...resto,
              Ano: watchAno,
              Sequencial: watchSequencial
            }

            await api.post('/boletimColunas', arrayGravacao)
          })
        )
      }

    } catch (error) {
      console.log('Erro em consultar as Colunas de Boletim')
    }
  }

  const funcaoGravaFeriadoFinanceiro = async () => {
    try {

      const consultaFeriados = await api.get('/feriadoFinanceiro/list', {
        params: {
          Ano: periodoSelecionado?.Ano,
        }
      })

      if (consultaFeriados.data.length > 0) {

        let dadosRetornados = consultaFeriados.data;
        await Promise.all(
          dadosRetornados.map(async (feriadoFinanceiro: any) => {
            const dataOriginal = feriadoFinanceiro.DataFeriado;
            const [, mes, dia] = dataOriginal.split('-');
            const dataCorrigida = `${watchAno}-${mes}-${dia}`;

            feriadoFinanceiro.DataFeriado = dataCorrigida;

            const feriadoGravacao = {
              EmpresaId: feriadoFinanceiro.EmpresaId,
              DataFeriado: dataCorrigida,
              Descricao: feriadoFinanceiro.Descricao,
              Fixo: feriadoFinanceiro.Fixo,
              DataFeriadoString: ''
            }

            await api.post('/feriadoFinanceiro/createFeriadosPeriodo', feriadoGravacao)
          })
        )
      }

    } catch (error) {
      console.log('Erro em consultar os Planos de Pagamento')
    }
  }

  const onSubmit = async () => {

    setLoading(true)
    // Validações 
    if (!watchAno) {
      toast.showToast({ severity: 'error', summary: 'Erro', detail: 'Selecione o ano' });
      setLoading(false)
      return
    }

    if (!watchSequencial) {
      toast.showToast({ severity: 'error', summary: 'Erro', detail: 'Selecione o sequencial' });
      setLoading(false)
      return
    }

    if (!watchDescricao) {
      toast.showToast({ severity: 'error', summary: 'Erro', detail: 'Preencha a descrição' });
      setLoading(false)
      return
    }

    // Salvando dados
    await funcaoGravaPeriodo()
    await funcaoSalvaParametro()
    await funcaoGravaTurmas()
    await funcaoGravaOfertaTurma()
    await funcaoGravaNivelSequencia()
    await funcaoGravaPlanoPagamento()
    await funcaoGravaFeriadoFinanceiro()
    await funcaoGravaBoletimColunas()

    setLoading(false)

  };

  const handleSelecionarTodos = (e: any) => {
    const isChecked = e.target.checked;

    // Atualiza o estado booleano
    setTodosSelecionados(isChecked);

    // Marca ou desmarca todos com base no checkbox
    const selecionarTodos = turmas.map(item => ({
      ...item,
      Selecionado: isChecked ? 1 : 0
    }));

    // Atualiza o estado da lista de turmas com os itens marcados/desmarcados
    setTurmas(selecionarTodos);
  };

  const handleInverterSelecao = () => {
    const novaLista = turmas.map(item => ({
      ...item,
      Selecionado: item.Selecionado === 1 ? 0 : 1
    }));

    setTurmas(novaLista);
  };

  useEffect(() => {
    load()
  }, [])

  useEffect(() => {
    if (watchAno && watchSequencial) {
      setValue('Descricao', `ANO BASE ${watchAno} PERÍODO: ${watchSequencial}`)
    } else {
      setValue('Descricao', '')
    }
  }, [watchAno, watchSequencial])

  return (

    <form onSubmit={handleSubmit(onSubmit)} className='pt-3' >
      <div className="grid crud-demo">
        <div className="col-12">
          <div className="card">
            <div className='flex justify-content-center align-items-center p-2 border-round-top-md text-white' style={{ backgroundColor: '#0772B3' }}>
              <h5 className="m-0 flex flex-1 align-items-center justify-content-center">Inicia Período por Turma</h5>
              <AjudaFormTela tarefa={tarefa} campo='' />
            </div>

            <div className='grid mt-2'>
              <div className='col-12 md:col-2'>
                <SCDropdown
                  name="Ano"
                  label="Ano"
                  options={COMBO_ANO}
                  optionLabel='descricao'
                  optionValue='value'
                  style={{ width: '100%' }}
                  value={watchAno}
                  onChange={(e: any) => setValue('Ano', e.target.value)}
                />
              </div>

              <div className='col-12 md:col-2'>
                <SCDropdown
                  name="Sequencial"
                  label="Sequencial"
                  options={LISTA_SEQUENCIAL}
                  optionLabel='descricao'
                  optionValue='value'
                  style={{ width: '100%' }}
                  value={watchSequencial}
                  onChange={(e: any) => setValue('Sequencial', e.target.value)}
                />
              </div>

              <div className='col-12 md:col-6'>
                <SCInputText
                  name="Descricao"
                  label="Descrição"
                  style={{ width: '100%', height: 32, fontSize: 12 }}
                  control={control}
                />
              </div>

              <div className='col-6 md:col-2 mt-3'>
                <Button
                  label='Gravar'
                  icon="pi pi-check"
                  className="p-button col-3 md:col-4 p-button-success"
                  type='submit'
                  style={{ width: '100%' }}
                />
              </div>
            </div>
            <Divider />


            {loading ? <Loading full={false} /> : (
              <DataTable
                size='small'
                stripedRows
                ref={dt}
                value={turmas}
                onSelectionChange={(e) => setSelectedTurma(e.value)}
                dataKey="id"
                rows={10}
                rowsPerPageOptions={[5, 10, 25]}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="{first} a {last} de {totalRecords}"
                globalFilter={globalFilter}
                emptyMessage="Nenhum registro encontrado."
                header={null}
                responsiveLayout="scroll"
              >
                <Column field="Codigo" header="Turma" sortable headerStyle={{ width: 90 }}></Column>
                <Column field="Descricao" header="Descrição" sortable headerStyle={{ width: 800 }}></Column>

                <Column
                  header={
                    <div className="flex justify-content-between gap-4">
                      <SCCheckbox
                        label='Selecionar Todos'
                        name='selecionarTodos'
                        checked={todosSelecionados}
                        onChange={handleSelecionarTodos}
                      />
                      <SCCheckbox
                        label='Inverter Seleção'
                        name='inverterSelecao'
                        checked={inverterSelecao}
                        onChange={handleInverterSelecao}
                      />
                    </div>
                  }
                  body={(rowData: any) => (
                    <div className="col-12 flex justify-content-center">
                      <SCCheckbox
                        key={rowData.TurmaId}
                        checked={rowData.Selecionado === 1}
                        onChange={(e: CheckboxChangeParams) => handleCheckboxChange(rowData, e.checked)}
                        id={rowData.PlanosPagamentoId}
                        name="Selecionado"
                        value={rowData.Selecionado === 1}
                      />
                    </div>
                  )}
                  alignHeader='center'
                  align='center'
                />

              </DataTable>

            )}
          </div>
        </div>
      </div>
    </form>
  );
};

export default IniciaPeriodoTurma;
